<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: network-access.vue
  - Created by: ChanYing
  - Create Date: 2023-05-11 17:11
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" id="network-access">
    <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        :stroke="strokeColor" stroke-width="1.3" stroke-miterlimit="10"/>
    <path d="M2.92969 7.5H17.0703" :stroke="strokeColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.92969 12.5H17.0703" :stroke="strokeColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M10 17.2969C11.7259 17.2969 13.125 14.03 13.125 10C13.125 5.97005 11.7259 2.70312 10 2.70312C8.27411 2.70312 6.875 5.97005 6.875 10C6.875 14.03 8.27411 17.2969 10 17.2969Z"
        :stroke="strokeColor" stroke-width="1.3" stroke-miterlimit="10"/>
  </svg>
</template>

<script>
export default {
  name: "network-access-svg",
  props: {
    strokeColor: {
      type: String,
      default: "var(--body-aux-1)"
    }
  },
}
</script>

